function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "shoe_svg__a",
  d: "M1045.093 507.6h-7.98c-.244 0-.443.175-.443.39 0 .215.199.39.443.39h7.98c.245 0 .444-.175.444-.39 0-.215-.199-.39-.444-.39z"
}), React.createElement("path", {
  id: "shoe_svg__b",
  d: "M1036.233 503.7h3.547c.245 0 .443-.175.443-.39 0-.215-.198-.39-.443-.39h-3.547c-.244 0-.443.175-.443.39 0 .215.199.39.443.39z"
}), React.createElement("path", {
  id: "shoe_svg__c",
  d: "M1042.88 505.65c0-.215-.199-.39-.443-.39h-7.094c-.244 0-.443.175-.443.39 0 .215.199.39.443.39h7.094c.244 0 .443-.175.443-.39z"
}), React.createElement("path", {
  id: "shoe_svg__d",
  d: "M1060.61 510.323c0 .222-.19.39-.443.39h-7.294c-.484 0-.815-.276-.816-.276l-13.871-12.201c-.229-.201-.246-.567-.035-.752l.293-.258 14.316 12.593a.475.475 0 00.314.114h7.537v.39zm-3.103-4.29h-2.66c-.245 0-.443.174-.443.39 0 .215.198.39.443.39h2.66c1.617 0 2.868.982 3.071 2.34h-7.32l-14.187-12.482 6.692-5.888c.367 1.027 1.212 3.024 2.564 4.213 1.515 1.334 4.144 1.606 5.19 1.66v3.136h-1.047a.91.91 0 00-.763-.39c-.489 0-.887.35-.887.78 0 .43.398.78.887.78a.91.91 0 00.763-.39h1.047v2.34h-1.047a.91.91 0 00-.763-.39c-.489 0-.887.35-.887.78 0 .43.398.78.887.78a.91.91 0 00.763-.39h1.047v.39c0 .104.047.203.13.276l.887.78a.487.487 0 00.627 0 .357.357 0 000-.551l-.757-.666v-7.64c0-.215-.199-.39-.443-.39-.034 0-3.382-.017-5.007-1.446-1.664-1.464-2.535-4.47-2.543-4.5a.419.419 0 00-.312-.281.489.489 0 00-.432.1l-7.536 6.63v.001h-.001l-.606.534c-.552.486-.536 1.353.035 1.855l13.871 12.205a2.28 2.28 0 001.443.505h7.294c.746 0 1.33-.514 1.33-1.17v-.78c0-1.97-1.752-3.511-3.99-3.511z"
}), React.createElement("path", {
  id: "shoe_svg__e",
  d: "M1049.09 499.4v4.68c0 .216.199.39.443.39.245 0 .444-.174.444-.39v-4.68c0-.215-.2-.39-.444-.39s-.443.175-.443.39z"
}), React.createElement("path", {
  id: "shoe_svg__f",
  d: "M1052.184 498.147c.217 0 .407-.14.438-.335.035-.213-.133-.41-.375-.441-2.96-.374-5.489-2.026-6.762-4.417-.104-.195-.367-.278-.59-.187-.221.091-.317.323-.213.518 1.4 2.63 4.182 4.447 7.439 4.858a.503.503 0 00.063.004z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, React.createElement("use", {
  xlinkHref: "#shoe_svg__a",
  opacity: 0.2,
  transform: "translate(-1035 -489)"
}), React.createElement("use", {
  xlinkHref: "#shoe_svg__b",
  opacity: 0.2,
  transform: "translate(-1035 -489)"
}), React.createElement("use", {
  xlinkHref: "#shoe_svg__c",
  opacity: 0.2,
  transform: "translate(-1035 -489)"
}), React.createElement("use", {
  xlinkHref: "#shoe_svg__d",
  opacity: 0.2,
  transform: "translate(-1035 -489)"
}), React.createElement("use", {
  xlinkHref: "#shoe_svg__e",
  opacity: 0.2,
  transform: "translate(-1035 -489)"
}), React.createElement("use", {
  xlinkHref: "#shoe_svg__f",
  opacity: 0.2,
  transform: "translate(-1035 -489)"
}));

var SvgShoe = function SvgShoe(props) {
  return React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23"
  }, props), _ref, _ref2);
};

export default SvgShoe;